import React from 'react';

import Text from '/component/base/Text';

import {styles} from './BarLabel.style';

export const renderBarLabel =
  ({routeName, tabs}: any) =>
  ({focused}: any) => {
    const tab = tabs.find(({name}: any) => name === routeName) || {};
    const textStyle = [
      styles.tabBarTabText,
      focused && styles.tabBarBoldText,
      {
        textAlign: 'center',
        whiteSpace: 'nowrap',
      },
    ];
    return (
      <Text allowFontScaling maxFontSizeMultiplier={2} style={textStyle}>
        {tab.label}
      </Text>
    );
  };
